module.exports = __webpack_public_path__ + "img/img21.68ced5b1.png";